import { render, staticRenderFns } from "./ToeicListeningAndReadingScoreComponent.vue?vue&type=template&id=37674199&scoped=true&"
import script from "./ToeicListeningAndReadingScoreComponent.vue?vue&type=script&lang=js&"
export * from "./ToeicListeningAndReadingScoreComponent.vue?vue&type=script&lang=js&"
import style0 from "./ToeicListeningAndReadingScoreComponent.vue?vue&type=style&index=0&id=37674199&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37674199",
  null
  
)

export default component.exports